module.exports = __webpack_public_path__ + "static/media/style.6982e4b0.less";